import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {saveCandidateProfile} from '/redux/action/candidate.action';
import {credentialsEmail} from '/redux/selector/auth.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {allReportData} from '/redux/selector/report.selector';
import {withProps} from '/util/selector.util';

import {CreateCandidateProfile} from './CreateCandidateProfile';

export default connect(
  createStructuredSelector({
    userId,
    credentialsEmail,
    getReportData: allReportData,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
  dispatch => ({
    saveCandidateProfile: ({candidateId, body, reportData, sendEvent}: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        saveCandidateProfile({
          candidateId,
          body,
          allReportData: reportData,
          sendEvent,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      saveCandidateProfile: (candidateId: any, body: any, sendEvent: any) => {
        const {getReportData} = stateProps;
        return dispatchProps.saveCandidateProfile({
          candidateId,
          body,
          reportData: getReportData,
          sendEvent,
        });
      },
    };
  },
)(CreateCandidateProfile);
